import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton';
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList';
import { StandardDialog } from '@ifca-root/react-component/src/components/Dialog/StandardDialog';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg';
import TextSeparator from '@ifca-root/react-component/src/components/Typography/TextSeparator';
import {
	IconButton,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListItemText,
	Menu,
	MenuItem,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { Auditor } from 'assets';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import { PosPermission, useGetExportedStatisticListingQuery, useGetOutletQuery, useGetUsersByAccountQuery, useStatisticExportDeleteMutation } from 'generated/graphql';
import { formatDate } from 'helpers/hooks/formatDate';
import { useMenuOption } from 'helpers/hooks/useMenuOption';
import { usePermissionChecker } from 'helpers/hooks/usePermissionChecker';
import { useFuseSearch } from 'helpers/hooks/useSearch';
import { useSnackBar } from 'helpers/hooks/useSnackBar';
import { SystemMsgs } from 'helpers/SystemMsg';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';

export const StatisticTransactionList = () => {
	useEffect(() => {
		console.log('StatisticTransactionList');
	}, []);

		
	const { anchorEl, menu, handleClick, handleClose } = useMenuOption();
	const { handlePermDisabled } = usePermissionChecker();
		const [openDeleteDialog, setDeleteDialog] = useState(false);

	const outletID = localStorage.getItem('latestOutlet');
	const user = JSON.parse(localStorage.getItem('loggedInUser'));

	const history = useHistory();
	const { filteredList, handleSearch, setOriginalListing } = useFuseSearch();

	const {
		data: { getExportedStatisticListing } = { getExportedStatisticListing: [] },
		loading: listLoading,
		refetch
	} = useGetExportedStatisticListingQuery({
		fetchPolicy: 'network-only',
		variables: {
			outletID: outletID,
		},
		onError: error => {
			console.log('error');
		},
	});
		const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
			SnackBarContext as any,
		);

		const [StatisticExportDelete, { loading: StatisticDeleteloading }] = useStatisticExportDeleteMutation()

  const {
			data: { getUsersByAccount } = { getUsersByAccount: [] },
		} = useGetUsersByAccountQuery({
			variables: {
				accountID: user?.accountID,
			},
			fetchPolicy: 'network-only',
	});

	const createdByName = ID => {
		return getUsersByAccount?.find(x => x.ID === ID)?.name || ''
	}


	const {
		called: ouletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});

	useEffect(() => {
		if (getExportedStatisticListing && getExportedStatisticListing?.length > 0 && !listLoading) {
			setOriginalListing(getExportedStatisticListing);
		}
	}, [getExportedStatisticListing, listLoading]);



	console.log(menu,'menu')

  const [Simple, setSimple] = useState(false)
	const { snackFunc, snackBarMessage, openSnackBar, close } = useSnackBar()

	const Delete = () => {
    snackFunc('Statistic Delete Successfully', false)
    refetch()
  }

	const onClickDelete = () => {
    StatisticExportDelete({
      variables: {
        outletID: outletID,
        accountID: user?.accountID ,
        batchNo: Number(menu.obj?.batchNo || 0),
      }
    }).then(i => {
      i.data.StatisticExportDelete === true
        ? Delete()
        : snackFunc('Statistic Delete Failed', false)
    })
  }
	const CancelDialog = (
    <StandardDialog
      fullWidth={true}
      open={Simple}
      onClose={() => setSimple(false)}
      sections={{
        header: {
          title: `Delete Statstic`,
        },
        body: () => (
          <>
            <div className="content-container">
              <span className=" mdTitle">
                Do you want to delete Statistic on {formatDate(menu.obj?.Date)} ?
              </span>
            </div>
          </>
        ),
        footer: {
          actions: [
            {
              displayText: 'Cancel',
              props: {
                onClick: () => setSimple(false),
                variant: 'contained',
                color: 'primary',
              },
            },
            {
              displayText: 'Delete',
              props: {
                onClick: () => {
                  setSimple(false)
                  onClickDelete()
                },
                variant: 'contained',
                color: 'primary',
              },
            },
          ],
        },
      }}
    />
  )

	return (
		<>
			{listLoading && <Loading />}
			{outletLoading && <Loading />}
			{StatisticDeleteloading && <Loading />}
			<MainHeader
				mainBtn="back"
				onClick={() => {
					history.push({
						pathname: `/menu/outlet-app/account-journals`,
					});
				}}
				smTitle="Outlet App"
				title={getOutlet[0]?.name}
				routeSegments={[
					{ name: '../' },
					{ name: 'Statistic Transaction', current: true },
				]}
			/>

			<SearchHeader
				title="Statistic Transaction Listing"
				value={`${filteredList?.length ?? 0}`}
				onChangeAction={e => {
					handleSearch(`'"${e?.target?.value}"`, []);
				}}
				fixed
				search
				onCloseAction={() => handleSearch('', [])}
			/>
							{console.log(filteredList,'filteredList')}
			<ContentWrapper float search>
				<List className="core-list">
					{getExportedStatisticListing?.length === 0 ? (
						<EmptyList title="No Record Found" />
					) : 
					(
						filteredList?.map((x, i) => (

							<>
								<ListItem key={i}>
									<ListItemText
										primary={
											<>
												<span className="xsTitle">
													{formatDate(x.Date)}
												</span>
											</>
										}
										secondary={
											<>
												<span className="desc icon-text">
													<span style={{ color: '#ff9800' }}>
													{formatDate(x.createdTs)}
													</span>
													&nbsp;<TextSeparator />
													<img
														src={Auditor}
														alt="ifca"
														width={12}
														loading="lazy"
														style={{ paddingRight: '4px' }}
													/>
													<span style={{ color: '#ff9800' }}>
														{createdByName(x.createdBy)}
													</span>
												</span>
											</>
										}
									/>
									<ListItemSecondaryAction>
										<IconButton 
										edge="end"
										onClick={e => {
											handleClick(e, x?.batchNo, i, x)
										}}
										>
											<MoreVert />
										</IconButton>
									</ListItemSecondaryAction>
								</ListItem>
							</>
						))
					)
					}
				</List>
				<Menu
					id="menu-list"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={handleClose}
					onClick={handleClose}
				>
					<>
						<MenuItem
							disabled={handlePermDisabled({
								outletID: outletID,
								permEnum: PosPermission.GeneralSettingUomUpdate,
							})}
							onClick={() => {
								history.push({
									pathname: `/menu/outlet-app/account-journals/statistic-transaction/detail`,
									state: menu.obj,

								});
							}}
						>
								View
						</MenuItem>
						<MenuItem
							disabled={handlePermDisabled({
								outletID: outletID,
								permEnum: PosPermission.GeneralSettingUomDelete,
							})}
							onClick={() => setSimple(true)}
						>
							<span className="">Delete</span>
						</MenuItem>
					</>
				</Menu>
					{CancelDialog}
				<FloatButton
					onClick={() =>
						history.push(`/menu/outlet-app/account-journals/statistic-transaction/add`)
					}
				/>
			</ContentWrapper>
			<SnackBarMsg
        open={openSnackBar}
        message={snackBarMessage}
        setOpen={setOpenSnackBar}
      />
		</>
	);
};
